import type { Router } from 'vue-router';

export function useRouteMeta(router?: Router) {
  const getMeta = (routeName: string) => router?.resolve({ name: routeName })?.meta;

  const getMetaLabel = (routeName: string) =>
    (getMeta(routeName)?.label as string | undefined) ?? routeName;

  const getMetaDescription = (routeName: string) =>
    getMeta(routeName)?.description as string | undefined;

  const getMetaIcon = (routeName: string) => getMeta(routeName)?.icon as string | undefined;

  return { getMeta, getMetaDescription, getMetaIcon, getMetaLabel };
}
